import React, { FC, useState } from 'react';
import { ButtonSizes, ButtonTypes, ButtonVariants, IButtonProps } from '@components/Button/types';
import './styles.scss';

export const Button: FC<IButtonProps> = ({
  label,
  type = ButtonTypes.button,
  variant = ButtonVariants.primary,
  size = ButtonSizes.medium,
  isDisabled = false,
  iconPrepend = null,
  iconAppend = null,
  title,
  handleClick,
  ...rest
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const buttonClassName = `button ${variant && `button-${variant}`} ${size && `button-${size}`} ${isDisabled ? 'is-disabled' : ''}`;

  return (
    <button
      className={buttonClassName}
      type={type}
      disabled={isDisabled}
      onClick={handleClick}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      {...rest}
    >
      {iconPrepend && (
        <span className="button-prepend-icon" role="presentation">
          {iconPrepend}
        </span>
      )}
      {label && <span className="button-label">{label}</span>}
      {iconAppend && (
        <span className="button-append-icon" role="presentation">
          {iconAppend}
        </span>
      )}
      {showTooltip && title && <span className="tooltip">{title}</span>}
    </button>
  );
};
